module.exports = __webpack_public_path__ + "img/四川天府新区正兴幼儿园.25ae1355.jpg";